import { SVGProps } from 'react';

const SwitchCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5M6 8l3-3-3-3m7 3h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5m3-3-3 3 3 3m-3-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default SwitchCamera;
